var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.catParent.name === 'Project Type')?_c('div',{staticStyle:{"padding":"0 2px"}},[_c('p',{class:{ tags: _vm.card === true, del: _vm.card === false }},[_vm._v(" "+_vm._s(_vm.catData.name)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }